import { IConsultant } from '../../types/consultation.types';

export const formatManualRegistrationSource = (student: IConsultant) =>
  `${student.source} by ${student!.createdBy!.username}`;
